import {
  useInfinitePageConfigSetQuery,
  useInfinitePostProjectSetDailyQuery,
  useInfinitePostSetQuery,
  usePageConfigSetQuery,
  usePostCountDailyQuery,
  usePostCountQuery,
  useSocialPageGroupSetQuery,
  useWatermarkSetQuery,
} from "@smp/graphql";
import { queryGetMainKey } from "@smp/utils";
import { useQueryClient } from "react-query";
import { useUpdateEffect } from "react-use";

import { useQueryWatermarkConfig } from "@/queries/watermark";

const GQL_KEYS = [
  useInfinitePostSetQuery.getKey(),
  useInfinitePageConfigSetQuery.getKey(),
  useSocialPageGroupSetQuery.getKey(),
  queryGetMainKey(usePostCountDailyQuery),
  usePostCountQuery.getKey(),
  queryGetMainKey(useWatermarkSetQuery),
  queryGetMainKey(useInfinitePostProjectSetDailyQuery),
  queryGetMainKey(usePageConfigSetQuery),
];

const REST_API_KEYS = [useQueryWatermarkConfig.KEY];

/**
 * Invalidate queries on change organization id
 * @param organizationId
 */
export const useQueryInvalidation = (organizationId: number | null) => {
  const queryClient = useQueryClient();

  useUpdateEffect(() => {
    queryClient.cancelQueries();

    queryClient
      .getQueryCache()
      .getAll()
      .forEach((q) => {
        const mainKey = Array.isArray(q.queryKey) ? q.queryKey[0] : q.queryKey;

        if (typeof mainKey === "string" && mainKey.startsWith("datafan")) {
          queryClient.invalidateQueries(mainKey);
        }
      });

    GQL_KEYS.forEach((gqlKey) => {
      queryClient.invalidateQueries(gqlKey);
    });

    REST_API_KEYS.forEach((apiKey) => {
      queryClient.invalidateQueries(apiKey);
    });
  }, [organizationId]);
};
